// extracted by mini-css-extract-plugin
export default {"label":"FormLabel__label___3caB4"};